export default {
  methods: {
    backClick: function backClick() {
      this.$router.back();
    }
  }
};